import { render, staticRenderFns } from "./livestreams.vue?vue&type=template&id=3f14313f&scoped=true"
import script from "./livestreams.vue?vue&type=script&lang=js"
export * from "./livestreams.vue?vue&type=script&lang=js"
import style0 from "./livestreams.vue?vue&type=style&index=0&id=3f14313f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f14313f",
  null
  
)

export default component.exports